/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {Data} from '../model/data';
import {ObjectQuery} from '../model/objectQuery';
import {ObjectQueryFilter} from '../model/objectQueryFilter';
import {Resource} from '../model/resource';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {ContentDataByDataviewDTO} from "../model/contentDataByDataviewDTO";
import {UpdateData} from "../model/updateData";
import {NewsletterSubscriptionNode} from '../model/newsletterSubscriptionNode';
import {PageData} from '../model/pageData';


@Injectable()
export class EngineDataQueryService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * downloadQueryByDataview
     *
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param queryFilter queryFilter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadQueryByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, queryFilter: ObjectQueryFilter, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
    public downloadQueryByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, queryFilter: ObjectQueryFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
    public downloadQueryByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, queryFilter: ObjectQueryFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
    public downloadQueryByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, queryFilter: ObjectQueryFilter, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadQueryByDataviewUsingPOST.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling downloadQueryByDataviewUsingPOST.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling downloadQueryByDataviewUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling downloadQueryByDataviewUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/csv;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Resource>(`${this.basePath}/api/query/object/dataview/${encodeURIComponent(String(id))}/download/csv`,
            queryFilter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * downloadQueryByPdf
     *
     * @param xDataStoreID X-DataStoreID
     * @param queryFilter queryFilter
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadQueryByPdfUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
    public downloadQueryByPdfUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
    public downloadQueryByPdfUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
    public downloadQueryByPdfUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadQueryByPdfUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling downloadQueryByPdfUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling downloadQueryByPdfUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/csv;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Resource>(`${this.basePath}/api/query/object/table/${encodeURIComponent(String(table))}/download/pdf`,
            queryFilter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }



    /**
     * downloadQueryByTable
     *
     * @param xDataStoreID X-DataStoreID
     * @param queryFilter queryFilter
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadQueryByTableUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
    public downloadQueryByTableUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
    public downloadQueryByTableUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
    public downloadQueryByTableUsingPOST(xDataStoreID: string, queryFilter: ObjectQueryFilter, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling downloadQueryByTableUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling downloadQueryByTableUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling downloadQueryByTableUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/csv;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Resource>(`${this.basePath}/api/query/object/table/${encodeURIComponent(String(table))}/download/csv`,
            queryFilter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }

    /**
     * downloadQuery
     *
     * @param query query
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadQueryUsingPOST(query: ObjectQuery, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
    public downloadQueryUsingPOST(query: ObjectQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
    public downloadQueryUsingPOST(query: ObjectQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
    public downloadQueryUsingPOST(query: ObjectQuery, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling downloadQueryUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/csv;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Resource>(`${this.basePath}/api/query/object/download/csv`,
            query,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * downloadSaveQueryDoc
     *
     * @param xDataStoreID Le code du datastore/tenant
     * @param displayMode Format du résultat
     * @param format Format de la sortie du ficher : pdf ou xlsx
     * @param id Identifiant de la requête
     * @param token Token de la requête
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public downloadSaveQueryDocUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', format?: string, exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
     public downloadSaveQueryDocUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', format?: string, exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
     public downloadSaveQueryDocUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', format?: string, exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
     public downloadSaveQueryDocUsingGET(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', format?: string, exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any> X_PARTNER_ID);
         }
         if (displayMode !== undefined && displayMode !== null) {
             queryParameters = queryParameters.set('displayMode', <any>displayMode);
         }
         if (format !== undefined && format !== null) {
             queryParameters = queryParameters.set('format', <any>format);
         }
         if (exportedColumnsCodes !== undefined && exportedColumnsCodes !== null) {
             queryParameters = queryParameters.set('exportedColumnsCodes', <any>exportedColumnsCodes);
         }
         if (exportedColumnsLabels !== undefined && exportedColumnsLabels !== null) {
             queryParameters = queryParameters.set('exportedColumnsLabels', <any>exportedColumnsLabels);
         }
         if (id !== undefined && id !== null) {
             queryParameters = queryParameters.set('id', <any>id);
         }
         if (token !== undefined && token !== null) {
             queryParameters = queryParameters.set('token', <any>token);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<Resource>(`${this.basePath}/api/query/object/download/save-query/doc`,
             {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
             }
         );
     }

    /**
     * downloadSaveQuery
     *
     * @param xDataStoreID Le code du datastore/tenant
     * @param displayMode Format du résultat
     * @param id Identifiant de la requête
     * @param token Token de la requête
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadSaveQueryUsingGET1(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'body', reportProgress?: boolean): Observable<Resource>;
    public downloadSaveQueryUsingGET1(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Resource>>;
    public downloadSaveQueryUsingGET1(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Resource>>;
    public downloadSaveQueryUsingGET1(xDataStoreID?: string, X_PARTNER_ID?: string, displayMode?: 'LIST' | 'CONTENU' | 'ALL', exportedColumnsCodes?: string[], exportedColumnsLabels?: string[], id?: string, token?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any> X_PARTNER_ID);
        }
        if (displayMode !== undefined && displayMode !== null) {
            queryParameters = queryParameters.set('displayMode', <any> displayMode);
        }
        if (exportedColumnsCodes !== undefined && exportedColumnsCodes !== null) {
            queryParameters = queryParameters.set('exportedColumnsCodes', <any>exportedColumnsCodes);
        }
        if (exportedColumnsLabels !== undefined && exportedColumnsLabels !== null) {
            queryParameters = queryParameters.set('exportedColumnsLabels', <any>exportedColumnsLabels);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any> id);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any> token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/csv;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Resource>(`${this.basePath}/api/query/object/download/save-query/csv`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
                responseType: 'blob' as 'json'
            }
        );
    }

    /**
     * find
     *
     * @param xDataStoreID X-DataStoreID
     * @param column column
     * @param search search
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findUsingPOST(xDataStoreID: string, column: string, search: string, table: string, observe?: 'body', reportProgress?: boolean): Observable<Array<any>>;
    public findUsingPOST(xDataStoreID: string, column: string, search: string, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<any>>>;
    public findUsingPOST(xDataStoreID: string, column: string, search: string, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<any>>>;
    public findUsingPOST(xDataStoreID: string, column: string, search: string, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling findUsingPOST.');
        }

        if (column === null || column === undefined) {
            throw new Error('Required parameter column was null or undefined when calling findUsingPOST.');
        }

        if (search === null || search === undefined) {
            throw new Error('Required parameter search was null or undefined when calling findUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling findUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (column !== undefined && column !== null) {
            queryParameters = queryParameters.set('column', <any> column);
        }
        if (table !== undefined && table !== null) {
            queryParameters = queryParameters.set('table', <any> table);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<any>>(`${this.basePath}/api/query/simple`,
            search,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getQueryDataByDataview
     *
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param X_PARTNER_ID X_PARTNER_ID
     * @param page page
     * @param queryFilter queryFilter
     * @param size size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueryDataByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, page: number, queryFilter: ObjectQueryFilter, size: number, observe?: 'body', reportProgress?: boolean, partners?: Array<string>): Observable<Array<Data>>;
    public getQueryDataByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, page: number, queryFilter: ObjectQueryFilter, size: number, observe?: 'response', reportProgress?: boolean, partners?: Array<string>): Observable<HttpResponse<Array<Data>>>;
    public getQueryDataByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, page: number, queryFilter: ObjectQueryFilter, size: number, observe?: 'events', reportProgress?: boolean, partners?: Array<string>): Observable<HttpEvent<Array<Data>>>;
    public getQueryDataByDataviewUsingPOST(xDataStoreID: string, X_PARTNER_ID: string, id: string, page: number, queryFilter: ObjectQueryFilter, size: number, observe: any = 'body', reportProgress = false, partners?: Array<string>): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getQueryDataByDataviewUsingPOST.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling getQueryDataByDataview.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getQueryDataByDataviewUsingPOST.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getQueryDataByDataviewUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling getQueryDataByDataviewUsingPOST.');
        }

        if (size === null || size === undefined) {
            throw new Error('Required parameter size was null or undefined when calling getQueryDataByDataviewUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any> page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any> size);
        }
        if (partners) {
            partners.forEach((element) => {
                queryParameters = queryParameters.append('partners', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Data>>(`${this.basePath}/api/query/object/dataview/${encodeURIComponent(String(id))}`,
            queryFilter,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getQueryDataByTableAndColDistinct
     *
     * @param xDataStoreID X-DataStoreID
     * @param column column
     * @param queryFilter queryFilter
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueryDataByTableAndColDistinctUsingPOST(xDataStoreID: string, column: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Data>>;
    public getQueryDataByTableAndColDistinctUsingPOST(xDataStoreID: string, column: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Data>>>;
    public getQueryDataByTableAndColDistinctUsingPOST(xDataStoreID: string, column: string, queryFilter: ObjectQueryFilter, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Data>>>;
    public getQueryDataByTableAndColDistinctUsingPOST(xDataStoreID: string, column: string, queryFilter: ObjectQueryFilter, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getQueryDataByTableAndColDistinctUsingPOST.');
        }

        if (column === null || column === undefined) {
            throw new Error('Required parameter column was null or undefined when calling getQueryDataByTableAndColDistinctUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling getQueryDataByTableAndColDistinctUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling getQueryDataByTableAndColDistinctUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Data>>(`${this.basePath}/api/query/object/table/${encodeURIComponent(String(table))}/column/${encodeURIComponent(String(column))}`,
            queryFilter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getQueryDataByTable
     *
     * @param xDataStoreID X-DataStoreID
     * @param page page
     * @param queryFilter queryFilter
     * @param size size
     * @param table table
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueryDataByTableUsingPOST(xDataStoreID: string, page: number, queryFilter: ObjectQueryFilter, size: number, table: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Data>>;
    public getQueryDataByTableUsingPOST(xDataStoreID: string, page: number, queryFilter: ObjectQueryFilter, size: number, table: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Data>>>;
    public getQueryDataByTableUsingPOST(xDataStoreID: string, page: number, queryFilter: ObjectQueryFilter, size: number, table: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Data>>>;
    public getQueryDataByTableUsingPOST(xDataStoreID: string, page: number, queryFilter: ObjectQueryFilter, size: number, table: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getQueryDataByTableUsingPOST.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getQueryDataByTableUsingPOST.');
        }

        if (queryFilter === null || queryFilter === undefined) {
            throw new Error('Required parameter queryFilter was null or undefined when calling getQueryDataByTableUsingPOST.');
        }

        if (size === null || size === undefined) {
            throw new Error('Required parameter size was null or undefined when calling getQueryDataByTableUsingPOST.');
        }

        if (table === null || table === undefined) {
            throw new Error('Required parameter table was null or undefined when calling getQueryDataByTableUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any> page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any> size);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Data>>(`${this.basePath}/api/query/object/table/${encodeURIComponent(String(table))}`,
            queryFilter,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getQueryData
     *
     * @param page page
     * @param query query
     * @param size size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueryDataUsingPOST(page: number, query: ObjectQuery, size: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Data>>;
    public getQueryDataUsingPOST(page: number, query: ObjectQuery, size: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Data>>>;
    public getQueryDataUsingPOST(page: number, query: ObjectQuery, size: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Data>>>;
    public getQueryDataUsingPOST(page: number, query: ObjectQuery, size: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getQueryDataUsingPOST.');
        }

        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling getQueryDataUsingPOST.');
        }

        if (size === null || size === undefined) {
            throw new Error('Required parameter size was null or undefined when calling getQueryDataUsingPOST.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any> page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any> size);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Data>>(`${this.basePath}/api/query/object`,
            query,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * query
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryUsingGET(observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public queryUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public queryUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public queryUsingGET(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/query/object`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newData(body: UpdateData, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public newData(body: UpdateData, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public newData(body: UpdateData, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public newData(body: UpdateData, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling newData.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling newData.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/query/new`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param ObjectQueryFilter doit contenir la restriction pour avoir un enregistrement principal
     * @param xDataStoreID
     * @param id de la vue
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueryDataContentByDataview(body: ObjectQueryFilter, xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<ContentDataByDataviewDTO>;
    public getQueryDataContentByDataview(body: ObjectQueryFilter, xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentDataByDataviewDTO>>;
    public getQueryDataContentByDataview(body: ObjectQueryFilter, xDataStoreID: string, X_PARTNER_ID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentDataByDataviewDTO>>;
    public getQueryDataContentByDataview(body: ObjectQueryFilter, xDataStoreID: string, X_PARTNER_ID: string, id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getQueryDataContentByDataview.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getQueryDataContentByDataview.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling getQueryDataContentByDataview.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getQueryDataContentByDataview.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContentDataByDataviewDTO>('post',`${this.basePath}/api/query/object/dataview/${encodeURIComponent(String(id))}/content`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
    /**
     *
     *
     * @param body
     * @param xDataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateData(body: UpdateData, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public updateData(body: UpdateData, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public updateData(body: UpdateData, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public updateData(body: UpdateData, xDataStoreID: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateData.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateData.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/query/update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param xDataStoreID
         * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
         * @param reportProgress flag to report request and response progress.
         */
    public getPersonalIdByEmail(body: string, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getPersonalIdByEmail(body: string, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getPersonalIdByEmail(body: string, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getPersonalIdByEmail(body: string, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getPersonalIdByEmail.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPersonalIdByEmail.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post', `${this.basePath}/api/query/email`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère les produits d&#x27;un contact
     * Récupère toutes les données d&#x27;un type de produit spécifique (vol, hôtel, voiture, parking) associées à un contact
     * @param xDataStoreID
     * @param personalId
     * @param products
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPersonalProducts(xDataStoreID: string, personalId: number, products: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: Array<Data>; }>;
    public getPersonalProducts(xDataStoreID: string, personalId: number, products: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: Array<Data>; }>>;
    public getPersonalProducts(xDataStoreID: string, personalId: number, products: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: Array<Data>; }>>;
    public getPersonalProducts(xDataStoreID: string, personalId: number, products: Array<string>, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPersonalProducts.');
        }

        if (personalId === null || personalId === undefined) {
            throw new Error('Required parameter personalId was null or undefined when calling getPersonalProducts.');
        }

        if (products === null || products === undefined) {
            throw new Error('Required parameter products was null or undefined when calling getPersonalProducts.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (personalId !== undefined && personalId !== null) {
            queryParameters = queryParameters.set('personalId', <any>personalId);
        }
        if (products) {
            products.forEach((element) => {
                queryParameters = queryParameters.append('products', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: Array<Data>; }>('get',`${this.basePath}/api/query/personal/products`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xDataStoreID
     * @param affiId
     * @param personalId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPersonalConsents(xDataStoreID: string, affiId: string, personalId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<NewsletterSubscriptionNode>>;
    public getPersonalConsents(xDataStoreID: string, affiId: string, personalId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NewsletterSubscriptionNode>>>;
    public getPersonalConsents(xDataStoreID: string, affiId: string, personalId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NewsletterSubscriptionNode>>>;
    public getPersonalConsents(xDataStoreID: string, affiId: string, personalId: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPersonalConsents.');
        }

        if (affiId === null || affiId === undefined) {
            throw new Error('Required parameter affiId was null or undefined when calling getPersonalConsents.');
        }

        if (personalId === null || personalId === undefined) {
            throw new Error('Required parameter personalId was null or undefined when calling getPersonalConsents.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (affiId !== undefined && affiId !== null) {
            queryParameters = queryParameters.set('affiId', <any>affiId);
        }
        if (personalId !== undefined && personalId !== null) {
            queryParameters = queryParameters.set('personalId', <any>personalId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NewsletterSubscriptionNode>>('get', `${this.basePath}/api/query/personal/consents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupère le statut de fidélité d'un contact
     * Récupère le statut de fidélité d'un contact spécifique identifié par son identifiant et associé un tenant et un partenaire spécifique
     * @param xDataStoreID
     * @param affiId
     * @param personalId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPersonalLoyaltyStatus(xDataStoreID: string, affiId: string, personalId: number, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public getPersonalLoyaltyStatus(xDataStoreID: string, affiId: string, personalId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public getPersonalLoyaltyStatus(xDataStoreID: string, affiId: string, personalId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public getPersonalLoyaltyStatus(xDataStoreID: string, affiId: string, personalId: number, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getPersonalLoyaltyStatus.');
        }

        if (affiId === null || affiId === undefined) {
            throw new Error('Required parameter affiId was null or undefined when calling getPersonalLoyaltyStatus.');
        }

        if (personalId === null || personalId === undefined) {
            throw new Error('Required parameter personalId was null or undefined when calling getPersonalLoyaltyStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (affiId !== undefined && affiId !== null) {
            queryParameters = queryParameters.set('affiId', <any>affiId);
        }
        if (personalId !== undefined && personalId !== null) {
            queryParameters = queryParameters.set('personalId', <any>personalId);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: any; }>('get',`${this.basePath}/api/query/personal/loyalty`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /* Récupère l'historique des modifications des données d'une table
    *
    * @param body
    * @param xDataStoreID
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
    public getTableDataModificationHistory(body: { [key: string]: number; }, xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<PageData>;
    public getTableDataModificationHistory(body: { [key: string]: number; }, xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageData>>;
    public getTableDataModificationHistory(body: { [key: string]: number; }, xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageData>>;
    public getTableDataModificationHistory(body: { [key: string]: number; }, xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getTableDataModificationHistory.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTableDataModificationHistory.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PageData>('post', `${this.basePath}/api/query/history`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
